module.exports = __webpack_public_path__ + "static/carousel-4-124d056e1a9a4676a39aa56111a9e7b3.jpg";